import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdLock, MdLogin, MdPerson } from "react-icons/md";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [loginStep, setLoginStep] = useState('phone');

  async function init() {
    let _storedLoginStep = getCookie('loginStep');
    let _storedPhone = getCookie('loginPhone');

    if(_storedLoginStep) {
      setLoginStep(_storedLoginStep);
    }

    if(_storedPhone) {
      setPhone(_storedPhone);
    }
  }

  function changePhone() {
    setLoginStep('phone');
    setPhone('');
  }

  async function otpLogin() {
    if (!loading) {
      if (phone.trim().length >= 9 && phone.trim().length <= 10) {
        if (otp.trim().length > 0) {

          setLoading(true);
          await callApi("otp-login", { phone: `255${parseInt(phone, 10)}`, otp }).then((response) => {
            if (response.status === 1) {
              setCookie('userUuid', response.user.uuid);
              setCookie('userToken', response.user.token);

              //deleting login memory
              setCookie('loginStep', '', -100000);
              setCookie('loginPhone', '', -100000);

              appContext.tellMessage("Welcome....");
              appContext.navTo({
                item: 'dashboard',
              })
              appContext.refresh();

            } else {
              appContext.tellError(response.msg);
            }
          })
          setLoading(false);

        } else {
          appContext.tellError("Invalid Password");
        }
      } else {
        appContext.tellError("Invalid Email or Phone");
      }
    } else {
      appContext.tellInfo("Signing in, Please wait....")
    }
  }

  async function phoneLogin() {
    if (!loading) {
      if (phone.trim().length >= 9 && phone.trim().length <= 10) {
        
        setLoading(true);
        await callApi("phone-login", { phone: `255${parseInt(phone, 10)}`, }).then((response) => {
          if (response.status === 1) {
            setLoginStep('otp');
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);
        
      } else {
        appContext.tellError("Invalid Phone Number");
      }
    } else {
      appContext.tellInfo("Signing in, Please wait....")
    }
  }

  useEffect(() => {
    init()
  }, [ ])

  useEffect(() => {
    setCookie('loginStep', loginStep);
  }, [ loginStep ])

  useEffect(() => {
    setCookie('loginPhone', phone);
  }, [ phone ])

  return (
    <div
      className="Login"
    >
      <div
        className="body bg-surface mShadow1"
        style={{
          borderRadius: "20px"
        }}
      >
        <div className="container">
          <div className="row">
            
            <div className="col-md-12 mb-4 mt-4">
              <div
                style={{
                  maxWidth: "300px",
                  margin: "0 auto",
                }}
              >

                <div className="mb-4 mt-4 text-center">
                  <img
                    src={logo}
                    style={{
                      width: "70%",
                      height: "auto",

                    }}
                  />
                </div>

                <h6
                  style={{
                    fontSize: "28px"
                  }}

                  className="font-light mb-5 mt-4 text-center"
                >
                  School's Staff Login
                </h6>

                {
                  (loginStep === 'phone') ?
                  <>
                    <div
                      className="input-group"
                    >
                      <span className="input-group-text font-bold">+255</span>
                      <input
                        className="form-control"
                        onChange={(e) => setPhone(e.target.value)}
                        value={phone}
                        placeholder="XXX XXX XXX"
                        maxLength={10}
                        type="text"
                      />
                    </div>
                    <div className="form-text d-block">Write Phone number to get OTP</div>

                    <div
                      className="mb-4 mt-4"
                    >
                      <button
                        className="btn btn-primary btn-rounded btn-padded btn-block mSupportLoading font-orbitron-bold"
                        onClick={phoneLogin}
                      >
                        {(loading) ? getInlineLoader() : <> Get OTP Via SMS </>}
                      </button>
                    </div>
                  </>
                  :""
                }

                {
                  (loginStep === 'otp') ?
                  <>
                   

                    <div
                      className="input-group"
                    >
                      <span className="input-group-text font-bold"><MdLock className="text-primary" size={20} /> &nbsp; OTP &nbsp;</span>
                      <input
                        className="form-control"
                        onChange={(e) => setOtp(e.target.value)}
                        value={otp}
                        placeholder="XXXXXX"
                        type="password"
                      />
                    </div>
                    <div className="form-text d-block">Please enter the OTP sent to <span className="font-semi-bold">{`+255${parseInt(phone, 10)}`}</span></div>

                    <div className="text-end">
                      <h6
                        className="font-bold mt-2 mb-2 text-primary"
                        style={{
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                        onClick={changePhone}
                      >
                        Change Phone
                      </h6>
                    </div>

                    <div
                      className="mb-4 mt-4"
                    >
                      <button
                        className="btn btn-primary btn-rounded btn-padded btn-block mSupportLoading font-orbitron-bold"
                        onClick={otpLogin}
                      >
                        {(loading) ? getInlineLoader() : <>Login <MdLogin className="mNoMargin mNoPadding" size={24} /></>}
                      </button>
                    </div>
                  </>
                  :""
                }

              </div>
            </div>
             
          </div>
        </div>
      </div>
    </div>
  )
}